<template>
  <div class="columns is-multiline">
    <div class="column is-full">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Αναφορά Συστάσεων (CSV)</p>
        </header>
        <div class="card-content">
          <ReportDateRange
            :from.sync="from"
            :to.sync="to"
            :preset="activePreset"
            :validation-error="validationError"
            :range-in-days-label="rangeInDaysLabel"
            @preset="onRangePreset"
          />
          <div class="columns is-multiline" style="margin-top: 0.5rem">
            <div
              v-for="stat in referralStatsCards"
              :key="stat.label"
              class="column is-one-quarter"
            >
              <div class="box has-text-centered">
                <p class="heading">{{ stat.label }}</p>
                <p class="title is-4">{{ stat.value }}</p>
              </div>
            </div>
          </div>
          <p class="help has-text-grey">
            Τα KPI ακολουθούν το επιλεγμένο διάστημα: εγγραφές, ολοκληρωμένες
            qualifying παραγγελίες, 2×10.000 πόντοι ανά ολοκλήρωση και κουπόνια
            εγγραφής/ανταμοιβής.
          </p>
        </div>
        <footer class="card-footer">
          <div class="card-footer-item">
            <button
              :class="[
                'button',
                'is-primary',
                'is-fullwidth',
                referralExporting && 'is-loading',
              ]"
              :disabled="!canExport || referralExporting"
              type="button"
              @click="exportReferralReport"
            >
              Εξαγωγή συστάσεων CSV
            </button>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import reportDateRange from '@/mixins/reportDateRange';
import ReportDateRange from '@/views/Dashboard/views/Stats/components/ReportDateRange';

export default {
  components: { ReportDateRange },
  mixins: [reportDateRange],

  data() {
    return {
      referralExporting: false,
      referralStats: {},
    };
  },

  computed: {
    referralStatsCards() {
      const stats = this.referralStats || {};
      return [
        { label: 'Συστάσεις', value: stats.referrals || 0 },
        {
          label: 'Ολοκληρωμένες',
          value: stats.completed || stats.rewarded || 0,
        },
        { label: 'Πόντοι issued', value: stats.points_issued || 0 },
        { label: 'Κουπόνια issued', value: stats.coupons_issued || 0 },
      ];
    },
  },

  watch: {
    from() {
      if (this.from && this.to) this.loadReferralStats();
    },
    to() {
      if (this.from && this.to) this.loadReferralStats();
    },
  },

  mounted() {
    this.loadReferralStats();
  },

  methods: {
    onRangePreset(preset) {
      if (preset === 'custom') {
        this.onCustomDateChange();
      } else {
        this.applyPreset(preset);
      }
    },

    async loadReferralStats() {
      try {
        const { data } = await request.get('/referrals', {
          params: {
            count: 1,
            filters: { date_start: this.from, date_end: this.to },
          },
        });
        this.referralStats = data.summary || data.stats || {};
      } catch (error) {
        this.referralStats = {};
      }
    },

    async exportReferralReport() {
      if (!this.canExport) return;
      this.referralExporting = true;
      try {
        const response = await request.post(
          '/exports/referrals',
          { from: this.from, to: this.to },
          { responseType: 'blob', handlerEnabled: false },
        );
        const filename =
          this.extractFilename(response) ||
          `referrals_${this.from}_${this.to}.csv`;
        this.downloadBlob(response.data, filename);
        this.$notify({
          type: 'success',
          title: 'Η αναφορά εξήχθη',
          text: `Κατέβηκε το αρχείο ${filename}`,
        });
      } catch (error) {
        this.$notify({
          type: 'error',
          title: 'Αποτυχία εξαγωγής',
          text: 'Το αίτημα απέτυχε. Δοκιμάστε ξανά.',
        });
      } finally {
        this.referralExporting = false;
      }
    },

    extractFilename(response) {
      const cd =
        response && response.headers && response.headers['content-disposition'];
      if (!cd) return null;
      const match = /filename="?([^";]+)"?/i.exec(cd);
      return match ? match[1] : null;
    },

    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: 'text/csv;charset=utf-8' }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
    },
  },
};
</script>
